<template>
    <main class="app-content" v-if="agency">
        <aside class="fixed-sidebar">
            <side-bar :agency="agency"></side-bar>
        </aside>
        <campaigns :agency="agency"></campaigns>
    </main>
</template>

<script>
    import SideBar from './SideBar';
    
    import Campaigns from './Campaigns';

    import AgencyService from '../../services/agencies';

    export default {
        components: {
            SideBar,
	        Campaigns,
        },
        data() {
            return {
                agency: null,
                campaign: null
            }
        },
        methods: {
            getAgency() {
                AgencyService.getAgency(this.$route.params.agency, 'client').then(agency => {
                    this.agency = agency;
                }).catch(error => {
                })
            },
        },
        created() {
        },
        mounted() {
            this.getAgency();
        }
    }
</script>

<style lang="css">
</style>
